<div class="jodo-popup-area">
Please close the {{ data }} window to continue.
</div>
